<template>
  <div class="sample-page molecular-body">
    <!--<div class="breadcrumb">-->
    <!--<a-breadcrumb>-->
    <!--<a-breadcrumb-item>-->
    <!--<router-link to="/home">首页</router-link>-->
    <!--</a-breadcrumb-item>-->
    <!--<a-breadcrumb-item>分子分型数据库</a-breadcrumb-item>-->
    <!--</a-breadcrumb>-->
    <!--</div>-->

    <a-row class="molecular-breadcrumb">
      <a-col :span="12">
        <div class="breadcrumb breadcrumb-db">
          <div v-if="!parentSourceStr">
            Database（{{ pdData.total }} samples）
          </div>
          <div v-else v-html="parentSourceStr"></div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="mb-hosptail-name">
          <template v-if="hosptailName">合作医院选中：</template>
          <span class="mb-hosptails-name" :style="{ backgroundColor: defaultColor }" v-if="hosptailName">{{ hosptailName
}}
            <a-icon class="mb-hn-icon" type="close-circle" @click="resetHosptailName" />
          </span>
        </div>
      </a-col>
    </a-row>
    <a-row class="molecular-main">
      <a-col :span="12" class="mb-min-height">
        <div class="molecular-scatter-total">分子分型</div>
        <div id="molecular-svg" class="molecular-svg" style="min-height: 800px">
          <div v-if="pdData.pies && pdData.pies.length == 0" class="mb-data-none molecular-none">
            <div class="none-img"></div>
            <div class="text">暂无分子分型数据</div>
          </div>
        </div>

        <!-- <a-row type="flex" style="margin: 25px 0">
          <a-col flex="200px">
            <div class="m-m-sankey-info">
              <div class="m-m-s-database" @click="actionDefaultCk">
                Database from {{ pdData.total }} samples
              </div>
            </div>
            <div class="m-m-pies-info">
              <template v-for="(item, index) in pdData.pies">
                <div class="m-m-pies-item" :style="reckonStyle(item, index)">
                  <div v-if="item.percentage > 10" class="m-m-middle">
                    <p class="name">{{ item.name }}</p>
                    <p>({{ item.fullName }})</p>
                    <p>{{ item.total }}/{{ pdData.total }}</p>
                    <p>{{ item.percentage }}%</p>
                  </div>
                  <div
                    v-else
                    class="m-m-middle"
                    style="height: 25px; margin-top: -9px"
                  >
                    <p class="name">{{ item.name }} {{ item.percentage }}%</p>
                  </div>
                </div>
              </template>
            </div>
          </a-col>
          <a-col flex="auto">
            <div
              id="molecular-svg"
              class="molecular-svg"
              style="height: 700px"
            ></div>
          </a-col>
        </a-row> -->
      </a-col>
      <a-col :span="10" class="m-m-border">
        <div class="molecular-scatter-total">
          <div>存在变异的基因（{{ genesTotal }}）</div>
          <div><span>注：只显示Top 70 的基因</span></div>
        </div>
        <div class="molecular-scatter-main" :style="{ 'background-color': hexToRgba(actionColor, 0.2) }">
          <div class="molecular-scatter">
            <!-- <circle-packing
              v-if="geneData.length > 0 && !flag"
              :geneData="geneData"
            ></circle-packing> -->
            <circle-bubble v-if="geneData.length > 0 && !flag" :geneData="geneData"></circle-bubble>
            <div v-else class="molecular-scatter-none" :style="{
  display: geneData.length == 0 && !flag ? 'block' : 'none',
}">
              <div class="iconfont icon-shujukong"></div>
              <div class="text">无P/LP基因出现</div>
            </div>
          </div>
        </div>
      </a-col>
      <a-col :span="2" class="mb-min-height">
        <div class="molecular-scatter-total">合作医院</div>
        <div id="molecular-h" class="molecular-h">
          <div v-if="pdData.pies && pdData.pies.length == 0" class="mb-data-none hospital-none">
            <div class="none-img"></div>
            <div class="text">无合作医院信息</div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CirclePacking from "@/components/molecular/circlePacking";
import CircleBubble from "@/components/molecular/circleBubble";

export default {
  components: { CirclePacking, CircleBubble },
  data() {
    return {
      barDivHeight: 60,
      pdData: {},
      hsmtData: {},
      geneData: [],
      genesTotal: 0,
      hosId: "",
      hosptailName: "",
      flag: false,
      bReady: false,
      sLastDateInputofDoAjaxGetTooltip: "",
      cTooltip: "",
      parentSourceStr: "",
      actionColor: "#f2f2f2",
      defaultColor: "#6990E7",
      nodeGap: 10,
      selectedDataKeys: {},
      sankeyDataItemStyle: {
        Database: {
          color: "#D8D8D8",
          borderColor: "#D8D8D8",
        },
        NA: {
          color: "#845656",
          borderColor: "#845656",
        },
        HM: {
          color: "#5A9040",
          borderColor: "#5A9040",
        },
        ST: {
          color: "#405D90",
          borderColor: "#405D90",
        },
        BT: {
          color: "#904080",
          borderColor: "#904080",
        },
        Other: {
          color: "#9B9B9B",
          borderColor: "#9B9B9B",
        },
      },
      sankeyLayerStyle: [
        "#3062CF",
        "#DE3700",
        "#FF9000",
        "#029802",
        "#9B009B",
        "#0398C7",
        "#DF4076",
        "#124E78",
        "#FFC300",
      ],
    };
  },
  mounted() {
    this.getMTData();
    this.getGeneData(-1, "ALL", this.defaultColor);
  },
  methods: {
    /**
     * 统计基因返回接口：
     *  接口：GET /api/mt/q/genes?mtId=1&mtName=HM
     *  参数：mtId：分子分型ID；mtName：分子分型名称（ALL,精确匹配）；hosId：机构或医院id
     * 请求示例：http://localhost:8888/api/mt/q/genes?mtId=1&mtName=HM
     */
    getGeneData(mtId, mtName, color) {
      if (mtId == -1) {
        mtName = "ALL";
      }
      this.geneData.length = 0;
      this.genesTotal = 0;
      this.$get(
        "/mt/q/genes?hosId=" +
        this.hosId +
        "&mtId=" +
        mtId +
        "&mtName=" +
        mtName
      ).then((res) => {
        if (res.data.code == 1) {
          let resData = res.data.data.list;
          resData.forEach((item, index) => {
            let json = {
              name: item.geneName,
              value: item.nums,
              color: color,
              pieNum: [item.snpNums, item.fusionNums, item.commonNums]
            };
            this.geneData.push(json);
          });
          this.genesTotal = res.data.data.total;
          this.flag = false;
        }
      });
    },
    /**
     * 查询桑基图信息
     * 参数：hosId:机构或医院id
     * 接口：GET /api/mt/q/pd?hosId=12
     */
    getMTData() {
      let that = this;
      this.$get("/mt/q/pd?hosId=" + this.hosId).then((res) => {
        this.pdData = res.data.data;
        if (this.pdData.pies.length != 0) {
          this.pdData.pies.forEach((item, index) => {
            let itemIndex = index + 1;
            item["itemStyle"] = that.sankeyDataItemStyle[item.name];
            if (index == 1) {
              if (!item.children) {
                item.children = [
                  {
                    name: "toNull" + index,
                    showName: "toNull" + index,
                    itemStyle: {
                      color: "#fff",
                      opacity: 0,
                    },
                    lineStyle: {
                      color: "#fff",
                    },
                    mtId: 999999 + index,
                    total: item.total,
                    layer: 2,
                    children: null,
                  },
                ];
              } else {
                item.children.forEach((ary, index) => {
                  ary["itemStyle"] = {
                    color: that.sankeyLayerStyle[index],
                    borderColor: that.sankeyLayerStyle[index],
                  };
                });
              }
            } else {
              if (!item.children) {
                item.children = [
                  {
                    name: "toNull" + index,
                    showName: "toNull" + index,
                    itemStyle: {
                      color: "#fff",
                      opacity: 0,
                    },
                    lineStyle: {
                      color: "#fff",
                    },
                    mtId: 999999 + index,
                    total: item.total,
                    layer: 2,
                    children: null,
                  },
                ];
              } else {
                item.children.forEach((ary, index) => {
                  ary["itemStyle"] = {
                    color: that.sankeyLayerStyle[index],
                    borderColor: that.sankeyLayerStyle[index],
                  };
                });
              }
            }
          });
          this.pdData.pies.sort(function (a, b) {
            return a.name.localeCompare(b.name);
          });
          let dJson = {
            name: "Database",
            showName: "Database",
            mtId: 1000000,
            total: res.data.data.total,
            layer: 0,
            itemStyle: that.sankeyDataItemStyle["Database"],
            children: that.pdData.pies,
          };
          this.initSankey(
            this.traverseTree(dJson),
            this.traverseTreeLinks(dJson)
          );
          this.initBar(
            this.formatBarData(res.data.data.hosptailBar, this.defaultColor)
          );
        }
      });
    },
    /**
     * 根据层级和分子分型名称查询条图数据（单击饼图中某个分子分型联动条图数据）
     * /api/mt/q/hsbmt/{mtId}/{mtName}
     * @param mtId  分子分型ID
     * @param layer 层级（1,2,3,4）
     */
    getHsbmtData(mtId, layer) {
      if (mtId == -1) {
        layer = -1;
        this.defaultColor = "#6990E7";
      }
      this.$get("/mt/q/hsbmt?mtId=" + mtId + "&layer=" + layer).then((res) => {
        if (res.data.code == 1) {
          this.initBar(
            this.formatBarData(res.data.data.hosptailBar, this.defaultColor)
          );
        }
      });
    },
    /**
     * 根据医院/测序中心ID查询悬浮框数据（mouseenter 事件）
     * /api/mt/q/hsmt/{id}/{mark}/{mtId}/{layer}
     * @param id
     * @param mark 0:医院；1：测序中心
     * @param mtId 分子分型id
     * @param layer 层级（-1,1,2,3,4）
     * @return
     */
    getHsmt: async function (param, mark) {
      this.bReady = false;
      let strParam = param.id + "_" + mark;
      if (this.sLastDateInputofDoAjaxGetTooltip == strParam) {
        this.bReady = true;
        return;
      } else {
        this.sLastDateInputofDoAjaxGetTooltip = strParam;
      }
      let mtId = this.selectedDataKeys.mtId ? this.selectedDataKeys.mtId : -1;
      let layer = this.selectedDataKeys.layer
        ? this.selectedDataKeys.layer
        : -1;

      await this.$get(
        "/mt/q/hsmt/" +
        param.id +
        "/" +
        mark +
        "/" +
        mtId +
        "/" +
        layer +
        "?tm=" +
        new Date().getTime()
      ).then((res) => {
        this.hsmtData = res.data.data;
        let html = [];
        html.push('<div class="molecular-move-tip">');
        if (this.hsmtData.logImg) {
          html.push(
            '<div class="mmt-logo"><img src="' +
            this.hsmtData.logImg +
            '"/></div>'
          );
        }
        html.push('<div class="mmt-name">' + this.hsmtData.name + "</div>");
        html.push(
          '<div class="mmt-num">' +
          param.value +
          "/" +
          this.hsmtData.total +
          "</div>"
        );
        html.push(
          '<div class="mmt-num">(' + this.hsmtData.percentage + "%)</div>"
        );
        html.push("</div>");
        this.cTooltip = html.join(" ");
        this.bReady = true;
      });
    },
    initBar(data) {
      let that = this;
      let chartDom = document.getElementById("molecular-h");
      chartDom.style.height = data[0].length * 20 + "px";
      let myChart = this.$echarts.init(chartDom, null, { renderer: "svg" });
      let option;
      option = {
        title: {
          show: false,
          text: "世界人口总量",
          subtext: "数据来自网络",
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          formatter: (params, ticket, callback) => {
            let mark = 0;
            let paramsData = params.data;
            let strParam = paramsData.id + "_" + mark;

            if (that.sLastDateInputofDoAjaxGetTooltip == strParam) {
              return that.cTooltip;
            } else {
              that.getHsmt(paramsData, mark);
              //定时检查数据是否完成准备bReady, tooltip
              let itv = setInterval(function () {
                if (that.bReady === true) {
                  callback(ticket, that.cTooltip);
                  window.clearInterval(itv); //停止检查
                  setTimeout(function () {
                    that.sLastDateInputofDoAjaxGetTooltip = "";
                  }, 1500);
                }
              }, 100);
              return "Loading";
            }
          },
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
          boundaryGap: [0, 0],
        },
        yAxis: {
          axisLine: { show: false },
          axisTick: { show: false },
          data: data[0],
        },
        series: [
          {
            type: "bar",
            barWidth: 10,
            data: data[1],
          },
        ],
      };
      //       series: [{
      //   name: "Sale",
      //   type: "bar",
      //   data: [{
      //     value: 5,
      //     itemStyle: {
      //       borderColor: "rgba(16, 48, 232, 1)",
      //       borderWidth: 1,
      //       shadowColor: "rgba(65, 115, 194, 1)",
      //       shadowBlur: 5
      //     }
      //   }, 20, 36, 10, 10, 20, 4],
      //   itemStyle: {
      //     borderColor: "rgba(203, 21, 21, 1)",
      //     borderWidth: 1
      //   }
      // }]
      option && myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      myChart.on("click", function (params) {
        that.hosId = params.data.id;
        that.hosptailName = params.data.name;
        that.getMTData();
        that.getGeneData(-1, "ALL", that.defaultColor);
      });
    },
    formatBarData(data, color) {
      let that = this,
        result = [],
        yAxis = [],
        barData = [],
        itemStyle = {};
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          yAxis.push(item.name);
          if (that.hosId == item.id) {
            itemStyle = {
              color: color,
              borderColor: "#428EF7",
              borderWidth: 2,
              shadowColor: "#428EF7",
              shadowBlur: 6,
            };
          } else {
            itemStyle = {
              color: color,
            };
          }
          barData.push({
            value: item.total,
            name: item.name,
            id: item.id,
            itemStyle: itemStyle,
          });
        });
      }
      yAxis.reverse();
      barData.reverse();
      result.push(yAxis, barData);
      return result;
    },
    initSankey(data, links) {
      let that = this;
      let chartDom = document.getElementById("molecular-svg");
      let myChart = this.$echarts.init(chartDom, null, { renderer: "svg" });
      let option = {
        tooltip: {
          trigger: "item",
          formatter: function (a) {
            let data = eval(a["data"]);
            let result = "";
            if (data.target && data.target.indexOf("toNull") != -1) {
              result = "";
            } else if (data.target) {
              result = that.splitShowName(a.name);
            } else if (data.name == "Database") {
              result =
                that.splitShowName(a.name) + "（" + data.total + " samples）";
            } else {
              result =
                that.splitShowName(a.name) + "<br/>(" + data.fullName + ")";
            }
            return result;
          },
        },
        series: {
          type: "sankey",
          left: 2.0,
          top: 0,
          right: 20.0,
          bottom: 10,
          lineStyle: {
            color: "target",
            curveness: 0.5,
          },
          itemStyle: {
            normal: {
              borderWidth: 1,
            },
          },
          draggable: false,
          nodeWidth: 20,
          nodeGap: that.nodeGap,
          emphasis: {
            focus: "adjacency",
          },
          nodeAlign: "left",
          layoutIterations: 32,
          selectedMode: true,
          select: {
            label: {
              color: "#000",
              show: true,
            },
            itemStyle: {
              shadowColor: "#428EF7",
              shadowBlur: 10,
              borderColor: "#428EF7",
              borderWidth: 2,
              borderType: "solid",
            },
          },
          label: {
            normal: {
              position: "left",
              formatter: function (a) {
                let data = eval(a["data"]);
                let result = "";
                if (data.name == "Database") {
                  result = "Database from " + data.total + " samples";
                } else {
                  result = that.splitShowName(data.name);
                }
                return result;
              },
              color: "#162232",
              padding: [0, 10, 0, 10],
            },
          },
          levels: [
            {
              depth: 0,
              label: {
                show: true,
                position: "inside",
                rotate: 90,
                fontWeight: "600",
              },
            },
            {
              depth: 1,
              label: {
                position: "insideLeft",
                fontWeight: "600",
                align: "center",
                offset: [-100, 0],
                formatter: function (a) {
                  let data = eval(a["data"]);
                  if (data.percentage > 10) {
                    return (
                      that.splitShowName(data.name) +
                      "\n" +
                      data.fullName +
                      "\n" +
                      data.total +
                      "/" +
                      that.pdData.total +
                      "\n" +
                      data.percentage +
                      "%"
                    );
                  } else {
                    return (
                      that.splitShowName(data.name) +
                      " " +
                      data.percentage +
                      "%"
                    );
                  }
                },
              },
            },
          ],
          data: data,
          links: links,
        },
      };

      option && myChart.setOption(option);
      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      window.addEventListener("resize", function () {
        myChart.resize();
      });
      //注释的功能，是判断点击折线图的拐点。
      myChart.on("click", function (param) {
        //这里根据param填写你的跳转逻辑
        if (param.dataType == "node") {
          that.flag = true;
          if (param.data.name == "Database") {
            that.actionColor = that.defaultColor = "#6990E7";
          } else {
            that.actionColor = that.defaultColor = param.color;
          }
          that.selectedDataKeys = param.data;
          that.getGeneData(param.data.mtId, param.data.name, that.actionColor);
          that.getHsbmtData(param.data.mtId, param.data.layer);
          that.parentSourceStr = that.setUpSource(param);
        }
      });
    },
    splitShowName(str) {
      let result = "";
      if (str) {
        if (str.indexOf(">") != -1) {
          let strAry = str.split(">");
          result =
            strAry[0].split("#")[0] + " &nbsp;> " + strAry[1].split("#")[0];
        } else {
          result = str.split("#")[0];
        }
      } else {
        result = str;
      }
      return result;
    },
    setUpSource(param) {
      let result = [];
      if (param && param.data.parentSource.indexOf("_") != -1) {
        let splitAry = param.data.parentSource.split("_");
        splitAry.forEach((item, index) => {
          if (index != 0) {
            result.push('<span class="kailong"></span>');
          }
          result.push(item);
        });
        result.push(
          '<span class="total-sample" style="color:' +
          param.color +
          ";border-color: " +
          param.color +
          '">关联样本数：' +
          param.data.total +
          " (" +
          param.data.percentage +
          "%)</span>"
        );
      } else {
        result = [];
      }
      return result.join(" ");
    },
    traverseTree(node, parentTotal, parentSource, itemStyle) {
      let that = this;
      let total = node.total;
      let child = node.children,
        arr = [],
        label = { show: true, lineHeight: 16 };
      let json = {};
      json.name = node.showName;
      json.fullName = node.fullName;
      json.total = node.total;
      json.parentTotal = parentTotal;
      json.percentage = node.percentage;
      json.mtId = node.mtId;
      json.layer = node.layer;
      if (json.name.indexOf("toNull") != -1) {
        json.label = { show: false };
      } else {
        json.label = label;
      }
      if (node.depth != undefined) {
        json.depth = node.depth;
      }
      if (itemStyle) {
        json.itemStyle = itemStyle;
      } else {
        json.itemStyle = node.itemStyle;
      }
      if (parentSource) {
        json.parentSource = parentSource + "_" + node.name;
      } else {
        json.parentSource = node.name;
      }
      arr.push(json);
      if (child) {
        child.forEach(function (node) {
          if (node.itemStyle) {
            arr = arr.concat(
              that.traverseTree(node, total, json.parentSource, node.itemStyle)
            );
          } else {
            arr = arr.concat(
              that.traverseTree(node, total, json.parentSource, json.itemStyle)
            );
          }
        });
      }
      return arr;
    },
    traverseTreeLinks(node) {
      let that = this;
      let child = node.children,
        arr = [];
      if (child) {
        child.forEach(function (childs) {
          let json = {};
          json.source = node.showName;
          json.fullName = node.fullName;
          json.target = childs.showName;
          json.value = childs.total;
          if (json.name != "Database") {
            arr.push(json);
          }
          arr = arr.concat(that.traverseTreeLinks(childs));
        });
      }
      return arr;
    },
    actionDefaultCk() {
      this.flag = true;
      this.actionColor = this.defaultColor = "#f2f2f2";
      this.selectedDataKeys.mtId = -1;
      this.selectedDataKeys.layer = -1;
      this.getGeneData(-1, "ALL", "#f2f2f2");
      this.getHsbmtData(-1, -1);
      this.parentSourceStr = this.setUpSource();
    },
    resetHosptailName() {
      this.hosId = "";
      this.hosptailName = "";
      this.getMTData();
      this.getGeneData(-1, "ALL", "#6990E7");
    },
    reckonGrey() {
      let len = 3;
      let result = {
        width: "301px",
        marginLeft: "-110px",
        marginTop: 65 + "px",
      };
      if (this.pdData.pies) {
        let sumAll = 0;
        this.pdData.pies.forEach((item, index) => {
          if (index == 0) {
            sumAll = 700 * (item.percentage / 100) - this.nodeGap * 2 - 1;
          } else {
            sumAll += 700 * (item.percentage / 100) - 1;
          }
        });
        result.width = sumAll + "px";
        result.marginLeft = "-" + (sumAll / 2 - 40) + "px";
      }
      return result;
    },
    reckonStyle(param, index) {
      let result = {
        backgroundColor: param.itemStyle.color,
        height: "70px",
        marginTop: 0,
      };
      if (index == 0) {
        let len = param.children.length;
        result.height =
          700 * (param.percentage / 100) -
          this.nodeGap * len -
          (len - 3) +
          "px";
        result.marginTop = this.nodeGap * (len - 1) - 1 + "px";
      } else {
        result.height = 700 * (param.percentage / 100) + "px";
        result.marginTop = this.nodeGap - 2 + "px";
      }
      return result;
    },
    hexToRgba(hex, opacity) {
      return (
        "rgba(" +
        parseInt("0x" + hex.slice(1, 3)) +
        "," +
        parseInt("0x" + hex.slice(3, 5)) +
        "," +
        parseInt("0x" + hex.slice(5, 7)) +
        "," +
        opacity +
        ")"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.molecular-body {
  /deep/ .molecular-move-tip {
    padding: 0 20px;
    width: 100%;

    .mmt-logo {
      width: 100%;
      height: 30px;
      text-align: center;

      img {
        height: 30px;
      }
    }

    .mmt-name {
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      color: #162232;
      line-height: 17px;
      text-align: center;
    }

    .mmt-num {
      width: 100%;
      font-size: 16px;
      color: #162232;
      line-height: 22px;
      text-align: center;
    }
  }

  .breadcrumb {
    padding: 0 40px;
    height: 46px;
    line-height: 46px;
    background: #fff;

    /deep/ .ant-breadcrumb {
      display: inline-block;
    }
  }

  .molecular-breadcrumb {
    background-color: #fff;
    line-height: 46px;
    border: 1px solid #efefef;
  }

  .mb-hosptail-name {
    text-align: right;
    padding-right: 30px;
    font-size: 12px;

    .mb-hosptails-name {
      display: inline-block;
      color: #fff;
      height: 20px;
      line-height: 20px;
      padding: 0px 5px;
    }
  }

  .mb-hn-icon {
    margin-left: 10px;
    cursor: pointer;
  }

  .breadcrumb-db {
    font-size: 14px;
    color: #162232;
    border-top: 1px solid #fefefe;
    height: 45px;
    overflow: hidden;

    /deep/ .kailong {
      margin: 0 10px;
      width: 0;
      display: inline-block;
      vertical-align: initial;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 11px solid #4d84ff;
    }

    /deep/ .total-sample {
      font-size: 14px;
      line-height: 22px;
      border: 1px solid #5a9040;
      display: inline-block;
      padding: 0 8px;
      margin-left: 40px;
    }
  }

  .molecular-main {
    padding: 0 20px;
    padding-bottom: 50px;
    background-color: #fff;
  }

  .m-m-sankey-info {
    position: relative;
    height: 651px;
    width: 10%;
    float: left;
    margin-top: 51px;

    /deep/ .m-m-s-database {
      position: absolute;
      text-align: center;
      writing-mode: vertical-lr;
      cursor: pointer;
      width: 30px;
      height: 100%;
      line-height: 29px;
      background-color: #d8d8d8;
      font-size: 14px;
      font-weight: 500;
      color: #162232;
      margin-left: 20px;
      transform: rotate(-180deg);
      -ms-transform: rotate(-180deg);
      /* IE 9 */
      -moz-transform: rotate(-180deg);
      /* Firefox */
      -webkit-transform: rotate(-180deg);
      /* Safari 和 Chrome */
      -o-transform: rotate(-180deg);
      /* Opera */
    }
  }

  .m-m-pies-info {
    width: 90%;
    float: right;

    .m-m-pies-item {
      border: 1px solid #fff;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 18px;
      padding: 5px 0;
      margin-left: 40px;
      position: relative;

      p {
        margin: 0 0;
      }

      p.name {
        font-weight: bold;
      }
    }

    .m-m-middle {
      width: 100%;
      height: 70px;
      top: 50%;
      position: absolute;
      margin-top: -35px;
    }
  }

  .molecular-svg {
    width: 95%;
    min-height: 500px;
  }

  .m-m-border {
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
    // height: 712px;
  }

  .molecular-h {
    padding-left: 5px;
    min-height: 500px;
  }
}

.molecular-scatter-total {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #162232;
  line-height: 18px;
  padding: 25px 25px;

  span {
    font-size: 12px;
    color: #b1b1b1;
  }
}

.molecular-scatter-main {
  width: 413px;
  height: 413px;
  padding: 20px 20px;
  border-radius: 100%;
  background-color: #f2f2f2;
  margin: 15px auto;
}

.mb-min-height {
  min-height: 800px;
}

.mb-data-none {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  width: 100px;
  margin-top: -32px;
  margin-left: -50px;
  font-size: 12px;
  color: #cacaca;
  text-align: center;
  line-height: 32px;

  .none-img {
    width: 40px;
    height: 40px;
    margin: 0 auto;
    background: no-repeat center;
  }

  &.molecular-none {
    .none-img {
      background-image: url("../../assets/image/homeImg/marshalling.png");
    }
  }

  &.hospital-none {
    .none-img {
      background-image: url("../../assets/image/homeImg/hospital-none.png");
    }
  }
}

.molecular-scatter {
  position: relative;
  border-radius: 100%;
  background-color: #fff;
  border: 1px solid #d4d4d4;

  .molecular-scatter-none {
    position: absolute;
    display: none;
    top: 50%;
    z-index: 9;
    width: 100%;
    margin-top: -32px;
    font-size: 12px;
    color: #cacaca;
    text-align: center;
    line-height: 32px;

    .iconfont {
      font-size: 32px;
    }
  }
}

.molecular-scatter>.molecular-scatter {
  border: 0;
}

@media only screen and (min-width: 0) {
  .molecular-scatter-main {
    width: 563px;
    height: 563px;
  }

  .molecular-scatter {
    width: 523px;
    height: 523px;
  }
}

@media only screen and (min-width: 1580px) {
  .molecular-scatter-main {
    width: 740px;
    height: 740px;
  }

  .molecular-scatter {
    width: 700px;
    height: 700px;
  }
}
</style>